import { GET_COUNTRIES } from 'modules/dashboard/store/constants';

export const getCountries = () => ({
  type: GET_COUNTRIES,
});
